import React, { ReactNode, createContext, useContext, useState } from "react";

interface AppContextInterface {
  loading: {
    message: string;
    progress: number;
    isLoading: boolean;
  };
  setLoading: React.Dispatch<
    React.SetStateAction<{
      message: string;
      progress: number;
      isLoading: boolean;
    }>
  >;
}

const AppContext = createContext({} as AppContextInterface);
const AppProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState({
    message: "Loading...",
    progress: 25,
    isLoading: false,
  });
  return (
    <AppContext.Provider value={{ loading, setLoading }}>
      {children}
    </AppContext.Provider>
  );
};
export default AppProvider;

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) throw new Error("No Context found!");
  return context;
};
